import { HydrateOption } from '@core/enums';
import withWidget from '@hoc/withWidget';
import PromoCard from '@stories/Components/Cards/PromoCard/PromoCard';
import React from 'react';
import { PromoCardsStyles as S } from './PromoCards.styles';
import { withMotion } from '@hoc/withMotion';
import { useInView } from '@hooks/useInView';
const PromoCards = (props) => {
    const [elementRef, inView] = useInView({ threshold: 0.25 });
    return (React.createElement(S.MotionWrapper, { "data-in-view": inView },
        React.createElement(S.Container, { ref: elementRef },
            React.createElement(S.BackgroundEffect, null),
            React.createElement(S.CardGrid, null, props.cards.map((x, i) => (React.createElement(S.CardWrapper, { "data-offset": i, key: x.title },
                React.createElement(PromoCard, { ...x }))))))));
};
export default withWidget(withMotion(PromoCards), 'PromoCards', { hydrate: HydrateOption.InView });
